<template>
    <div>
        <app-page-header title="Services" subtitle="We love using our skills to help our clients succeed." />
        <div>
            <div v-for="(category, index) in categories" :key="index" class="service">
                <b-container>
                    <img :src="category.icon_purple" class="mx-auto d-block mb-3" />
                    <h3 class="text-center mb-4">{{category.name}}</h3>
                    <b-row class="align-items-center mt-5" :class="(index%2 == 0)? 'row-odd': 'row-even'">
                        <b-col lg="6" class="col-left">
                            <div class="image-block">
                                <img :src="category.picture" />
                            </div>
                        </b-col>
                        <b-col lg="6" class="col-right">
                            <p>{{ category.description }}</p>
                            <h5>We can help with</h5>
                            <b-list-group flush>
                                <b-list-group-item v-for="service in category.services" :key="service">
                                    <span class="square-icon"></span>
                                    <span class="text">{{ service }}</span>
                                </b-list-group-item>
                            </b-list-group>
                            <btn href="mailto:hello@csuitegroup.com" primary rounded class="mb-3 mt-3">Talk to us</btn>
                            <btn to="/portfolio" secondary rounded class="mb-3 mt-3 ml-3">Explore portfolio</btn>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </div>
    </div>
</template>
<script>
import ServicesData from '@/data/services.json';
import AppPageHeader from '@/components/global/AppPageHeader';
import Btn from '@/components/global/Btn';

export default {
    name: 'services',

    components: {
        AppPageHeader,
        Btn,
    },

    data() {
        return {
            categories: ServicesData,
        };
    },
};
</script>

<style lang="scss" scoped>
    img {
        max-width: 100%;
    }
    h3 {
        font-size: 40px;
        font-weight: 900;
        color: #000112;
    }
    h5 {
        font-size: 15px;
        color: #000112;
        text-transform: uppercase;
        opacity: 0.37;
        margin-bottom: 15px;
    }
    .row-odd {
        background-color: #ffffff;
        .col-left {
            @include media-breakpoint-up(lg) {
                order: 1;
            }
        }
        .col-right {
            max-width: 496px;
            margin-left: auto;
            margin-right: auto;
            @include media-breakpoint-up(lg) {
                order: 2;
                padding-left: 40px;
            }
        }
    }
    .row-even {
        .col-left {
            @include media-breakpoint-up(lg) {
                order: 2;
            }
        }
        .col-right {
            max-width: 496px;
            margin-left: auto;
            margin-right: auto;
            @include media-breakpoint-up(lg) {
                order: 1;
            }
        }
    }
    .image-block {
        position: relative;
        max-width: 496px;
        margin: 0px auto 30px;
        @include media-breakpoint-up(lg) {
            margin-left: 0;
            margin-right: 0;
        }
        img {
            width: 100%;
            height: 300px;
            object-fit: cover;
            object-position: center;
            @include media-breakpoint-up(md) {
                width: auto;
                height: auto;
            }
        }
        p {
            position: absolute;
            bottom: 0;
            color: #ffffff;
            padding: 10px;
            background-color: rgba(75, 46, 110, 0.8);
            margin-bottom: 0;
            font-size: 16px;
            font-weight: 500;
            line-height: 26px;
            @include media-breakpoint-up(md) {
                font-size: 18px;
                line-height: 30px;
                padding: 30px 40px;
            }
        }
    }
    .service {
        padding: 50px 0;
        @include media-breakpoint-up(md) {
            padding: 80px 0 100px;
        }
        &:nth-of-type(odd) {
            background-color: #ffffff;
        }
    }
    .list-group-item {
        font-size: 18px;
        padding: 0.4rem 0;
        background-color: transparent;
        border: none;
        .square-icon {
            width: 10px;
            height: 10px;
            background-color: $primary;
            display: inline-block;
        }
        span.text {
            color: #17032F;
            margin-left: 20px;
            display: inline-block;
        }
    }
</style>
